import {
  GET_BENEFICIARY_REPORT_LIST,
  GET_CASTE_REPORT_LIST,
  GET_CLASS_REPORT_LIST,
  GET_DAILYATTENDANCE_REPORT_LIST,
  GET_DAILY_REPORT_LIST,
  GET_NOTIFICATION_REPORT_LIST,
  GET_OVERSPEED_REPORT_LIST,
  GET_PRIMARYSCHOOL_REPORT_LIST,
  GET_ROLEWISE_ATTENDANCE_REPORT_LIST,
  GET_SCHOOLWITHDRIVER_REPORT_LIST,
  GET_SECONDARYSCHOOL_REPORT_LIST,
  GET_SOS_REPORT_LIST,
  GET_TOTALSCHOOL_REPORT_LIST,
  GET_VEHICLE_REPORT_LIST,
  GET_DAILYATTENDANCESCHOOL_REPORT_LIST,
  RESET_REPORT_DATA,
  GET_STUDENT_DAILY_ATTENDANCE_REPORT_LIST,
  SET_LOADER
} from "../actions/ReportsActions";

const initialState = {// initialize states
  totalSchoolReport: [],
  primarySchoolReport: [],
  secondarySchoolReport: [],
  schoolWithDriverReport: [],
  overspeedReport: [],
  sosReport: [],
  attendanceReport: [],
  roleWiseAttendanceReport: [],
  vehicleReport: [],
  classReport: [],
  studentTargetReport: [],
  casteReport: [],
  notificationReport: [],
  beneficiaryReport: [],
  schoolSummaryReport: [],
  dailyReport: [],
  dailyAttendanceSchoolReport: [],
  studentDailyAttendanceReport: [],
  isLoading: false,
};

const ReportsReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADER: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case GET_TOTALSCHOOL_REPORT_LIST: {// save total school reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        totalSchoolReport: action.payload ? action.payload : [],
      };
    }
    case GET_PRIMARYSCHOOL_REPORT_LIST: {// save total primary school reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        primarySchoolReport: action.payload ? action.payload : [],
      };
    }
    case GET_SECONDARYSCHOOL_REPORT_LIST: {// save total secondary school reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        secondarySchoolReport: action.payload ? action.payload : [],
      };
    }
    case GET_SCHOOLWITHDRIVER_REPORT_LIST: {// save school with driver reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        schoolWithDriverReport: action.payload ? action.payload : [],
      };
    }
    case GET_OVERSPEED_REPORT_LIST: {// save overspeed reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        overspeedReport: action.payload ? action.payload : [],
      };
    }
    case GET_SOS_REPORT_LIST: {// save sos reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        sosReport: action.payload ? action.payload : [],
      };
    }
    case GET_DAILYATTENDANCE_REPORT_LIST: {// save daily attendance reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        attendanceReport: action.payload ? action.payload : [],
      };
    }
    case GET_ROLEWISE_ATTENDANCE_REPORT_LIST: {// save role wise attendance reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        roleWiseAttendanceReport: action.payload ? action.payload : [],
      };
    }
    case GET_VEHICLE_REPORT_LIST: {// save vehicle reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        vehicleReport: action.payload ? action.payload : [],
      };
    }
    case GET_CLASS_REPORT_LIST: {// save class reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        classReport: action.payload ? action.payload : [],
      };
    }
    case GET_CASTE_REPORT_LIST: {// save caste reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        casteReport: action.payload ? action.payload : [],
      };
    }
    case GET_NOTIFICATION_REPORT_LIST: {// save notification reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        notificationReport: action.payload ? action.payload : [],
      };
    }
    case GET_BENEFICIARY_REPORT_LIST: {// save beneficiary reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        beneficiaryReport: action.payload ? action.payload : [],
      };
    }
    case GET_DAILY_REPORT_LIST: {// save beneficiary reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        dailyReport: action.payload ? action.payload : [],
      }
    }
    case GET_DAILYATTENDANCESCHOOL_REPORT_LIST: {// save daily attendance school reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        dailyAttendanceSchoolReport: action.payload ? action.payload : [],
      };
    }
    case GET_STUDENT_DAILY_ATTENDANCE_REPORT_LIST: {// save daily attendance school reports data into state 
      return {
        ...state,
        isLoading: false, // Hide loader
        studentDailyAttendanceReport: action.payload ? action.payload : [],
      };
    }
    case RESET_REPORT_DATA: {
      return {
        ...state,
        beneficiaryReport: [],
        totalSchoolReport: [],
        primarySchoolReport: [],
        secondarySchoolReport: [],
        schoolWithDriverReport: [],
        overspeedReport: [],
        sosReport: [],
        attendanceReport: [],
        roleWiseAttendanceReport: [],
        vehicleReport: [],
        classReport: [],
        casteReport: [],
        notificationReport: [],
        schoolSummaryReport: [],
        dailyReport: [],
        dailyAttendanceSchoolReport: [],
        studentDailyAttendanceReport: [],
        isLoading: false, // Hide loader
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default ReportsReducer;